import { useState } from "react";
import Check from "../../../assets/icons/Check.svg";
import { Minus, Plus } from "lucide-react";
import IvList from "../../../assets/icons/IvGray.svg";
import OnlineAndOffline from "./Online-Offline";
import cer1 from "../../../assets/used-images/certificateprint1.jpg";
import cer2 from "../../../assets/used-images/certificateprint2.jpg";
import Image from "../../ui/Image";
import { useUserSelection } from "../../../store/UserPayment";
import { useNavigate, useParams } from "react-router-dom";
import getToken from "../../../hooks/getToken";
import Riyal from "../../ui/riyal";
import { useTranslation } from "react-i18next";

const Details = ({ details }) => {
    return (
        <div className="!text-start">
            {details && (
                <article dangerouslySetInnerHTML={{ __html: details }} className="w-full" />
            )}
        </div>
    );
};

const Targets = ({ targets }) => {
    return (
        <div className="!text-start">
            {(targets && targets?.length > 0) && (
                <ul className="flex flex-wrap items-center mt-4 gap-x-8 gap-y-4 max-lg:flex max-lg:flex-wrap max-lg:gap-5">
                    {targets?.map((target, i) => (
                        <li key={target?.id || i} className="flex items-center gap-2">
                            <span>
                                <img src={Check} alt="target" />
                            </span>
                            <span className="text-wrap">{target?.title}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

const Goals = ({ goals }) => {
    return (
        <div className="space-y-5 py-4">
            {(goals && goals?.length > 0) && (
                <ul className="grid grid-cols-3 gap-4 max-lg:grid-cols-2 max-md:grid-cols-1">
                    {goals?.map((goal, i) => (
                        <li
                            key={goal?.id || i}
                            className="bg-secondary-tw text-white rounded-md py-4 px-2 relative !text-start"
                        >
                            <span className="bg-white size-7 absolute -top-4 rounded-sm right-3 flex items-center justify-center">
                                <span className="size-6 text-sm rounded-sm flex justify-center items-center bg-secondary-tw">
                                    {i + 1}
                                </span>
                            </span>
                            <span>{goal?.title}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

const Skills = ({ skills }) => {
    return (
        <div className="space-y-5 py-4">
            {(skills && skills?.length > 0) && (
                <ul className="grid grid-cols-3 gap-4 max-lg:grid-cols-2 max-md:grid-cols-1">
                    {skills?.map((goal, i) => (
                        <li
                            key={goal?.id || i}
                            className="bg-secondary-tw text-white rounded-md py-4 px-2 relative !text-start"
                        >
                            <span className="bg-white size-7 absolute -top-4 rounded-sm right-3 flex items-center justify-center">
                                <span className="size-6 text-sm rounded-sm flex justify-center items-center bg-secondary-tw">
                                    {i + 1}
                                </span>
                            </span>
                            <span>{goal?.title}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

const Content = ({ content }) => {
    const [iContent, setIContent] = useState(null);
    return (
        <div className="space-y-3">
            {
                (content && content?.length > 0)
                &&
                <ul className="grid gap-3 mt-3">
                    {
                        content.map((item) => (
                            <li key={item?.id} className="border rounded-md cursor-pointer !text-start"
                                onClick={() => setIContent(prev => (prev === item?.id ? null : item?.id))}>
                                <div className="flex justify-between items-center border bg-gray-200 rounded-md py-1 px-2">
                                    <span>
                                        {item?.title}
                                    </span>
                                    <div className="border-2 rounded-full size-5 border-black flex items-center justify-center">
                                        {item?.id !== iContent ?
                                            <button>
                                                <Plus size={15} color="black" fill="black" />
                                            </button>
                                            :
                                            <button>
                                                <Minus size={15} color="black" fill="black" />
                                            </button>
                                        }
                                    </div>
                                </div>
                                <ul>
                                    {
                                        item?.countent?.map((dataOfItem, ix) => (
                                            <li key={ix} className={`transition-all duration-150 ease-in-out ${item?.id === iContent ? 'max-h-[1100px] opacity-100' : 'max-h-0 opacity-0 py-0'} flex items-start gap-2 px-4 overflow-y-scroll !text-start ${(ix === 0 && item?.id === iContent) ? 'pt-2' : ''}`}>
                                                <div>
                                                    <img src={IvList} alt="list-icon" className="size-4 mt-1" />
                                                </div>
                                                <p className="text-base mb-1">
                                                    {dataOfItem?.title}
                                                </p>
                                            </li>
                                        ))

                                    }
                                </ul>
                            </li>
                        ))
                    }
                </ul>
            }
        </div>
    )
};

const Certificate = ({ certificates }) => {
    return (
        <div className="space-y-5  justify-content-center">
            <div className="mt-4 mb-4 relative text-gray-600 border-[1px] border-secondary-tw  rounded-md py-2 px-2 text-center h-40 max-lg:h-24" >
                <Image
                    src={cer1}
                    className={`w-full h-full`}
                    alt={'Certificate'}
                />
            </div>
            <div className="mt-4 mb-4 relative text-gray-600 border-[1px] border-secondary-tw  rounded-md py-2 px-2 text-center h-40 max-lg:h-24">
                <Image
                    src={cer2}
                    className={`w-full h-full`}
                    alt={'Certificate'}
                />
            </div>
            {
                certificates?.map((certificate, i) => (
                    <div className="mt-4 mb-4 relative text-gray-600 border-[1px] border-secondary-tw  rounded-md py-2 px-2 text-center h-40 max-lg:h-24" key={certificate?.id || i}>
                        <Image
                            src={certificate?.image}
                            className={`w-full h-full`}
                            alt={certificate?.title}
                        />
                    </div>
                ))
            }
        </div>
    );
};

const CertificateData = ({ fees }) => {
    const { t } = useTranslation();
    const token = getToken();
    const { id } = useParams();
    const navigate = useNavigate();
    const { setRowDetails, setSelectedPayment } = useUserSelection();

    const addFeeToRow = (feeId, feePrice, currency) => {
        setRowDetails(prev => ({
            ...prev,
            courseId: id,
            courseFeeId: feeId,
            courseFeePrice: feePrice
        }))

        setSelectedPayment(prev => ({
            ...prev,
            currencyTitle: currency.includes('ريال' || 'iyal') ? <Riyal /> : currency
        }))

        if (token) {
            navigate(`/training-courses/${id}/payment/way`);
        } else {
            navigate(`/login`)
        }
    };

    return (
        <div className="space-y-5">
            {(fees && fees?.length > 0) && (
                <ul className="grid grid-cols-3 gap-4 max-lg:grid-cols-2 max-md:grid-cols-1">
                    {fees?.map((fee, i) => (
                        <li
                            key={fee?.id || i}
                            className=" text-gray-600  rounded-md py-4 px-2 relative text-center border-2 border-secondary-tw">

                            <div className="font-bold d-flex align-items-center flex-column justify-content-center">
                                <span>{fee?.course_extra_fees?.title}</span>
                                <div className="d-flex align-items-center justify-content-center gap-2 mt-2">
                                    <p className='bg-primary-tw text-sm flex items-center gap-1 text-white px-3 py-1 rounded-md w-fit'>
                                        <span>
                                            {fee?.price}
                                        </span>
                                        <span>
                                            <Riyal color="white" />
                                        </span>
                                    </p>
                                    <div>
                                        <button
                                            className="px-3 py-1 rounded-md border-1 border-primary-tw text-sm flex items-center gap-1 text-primary-tw "
                                            onClick={() => addFeeToRow(fee.id, fee.price, fee.currency.title)}
                                        >
                                            {t('custom.pay-now')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

const TRCourseData = ({ course, comingFromOffer }) => {
    const { t } = useTranslation();
    const getFirstSectionDefault = () => {
        if (course?.description) {
            return 1;
        }

        if (!course?.description) {
            if (!course?.targets?.length) {
                if (!course?.goals?.length) {
                    return 4;
                }
                return 3;
            }
            return 2;
        }

        return 5;
    };

    const [section, setSection] = useState(getFirstSectionDefault());
    const returnedSection = {
        1: <Details details={course?.description} />,
        2: <Targets targets={course?.targets} />,
        3: <Goals goals={course?.goals} />,
        4: <Content content={course?.trainingProgram} />,
        5: <Certificate certificates={course?.certificate} />,
        6: <CertificateData fees={course?.extraFeesPrice} />,
        7: <Skills skills={course?.skills} />
    };

    return (
        <div className="my-4">
            <div className="scrolling lg:flex !gap-3 items-center py-3 max-lg:px-3">
                {
                    course?.description &&
                    <button
                        className={`!py-2 !px-4 rounded-lg !text-nowrap max-lg:!px-6 ${section === 1 ? "training-btn-seen" : "bg-[#F5F5F5] text-semi-gray"}`}
                        onClick={() => setSection(1)}
                    >
                        {t('training-courses.details')}
                    </button>
                }

                {
                    (course?.targets && course?.targets?.length > 0) &&
                    <button
                        className={`!py-2 !px-4 rounded-lg !text-nowrap max-lg:!px-6 ${section === 2 ? "training-btn-seen" : "bg-[#F5F5F5] text-semi-gray"}`}
                        onClick={() => setSection(2)}
                    >
                        {t('training-courses.target')}
                    </button>
                }

                {
                    (course?.goals && course?.goals?.length > 0) &&
                    <button
                        className={`!py-2 !px-4 rounded-lg !text-nowrap max-lg:!px-6  ${section === 3 ? "training-btn-seen" : "bg-[#F5F5F5] text-semi-gray"}`}
                        onClick={() => setSection(3)}
                    >
                        {t('training-courses.goals')}
                    </button>
                }

                {
                    (course?.skills && course?.skills?.length > 0) &&
                    <button
                        className={`!py-2 !px-4 rounded-lg !text-nowrap max-lg:!px-6  ${section === 7 ? "training-btn-seen" : "bg-[#F5F5F5] text-semi-gray"}`}
                        onClick={() => setSection(7)}
                    >
                        {t('training-courses.skills')}
                    </button>
                }

                {
                    (course?.trainingProgram && course?.trainingProgram?.length > 0) &&
                    <button
                        className={`!py-2 !px-4 rounded-lg !text-nowrap max-lg:!px-6 ${section === 4 ? "training-btn-seen" : "bg-[#F5F5F5] text-semi-gray"}`}
                        onClick={() => setSection(4)}
                    >
                        {t('training-courses.content')}
                    </button>
                }

                <button
                    className={`!py-2 !px-4 rounded-lg !text-nowrap max-lg:!px-6 ${section === 5 ? "training-btn-seen" : "bg-[#F5F5F5] text-semi-gray"}`}
                    onClick={() => setSection(5)}
                >
                    {t('training-courses.certificates')}

                </button>
                {course?.type_course !== 0 && (
                    <button
                        className={`!py-2 !px-4 rounded-lg !text-nowrap max-lg:!px-6 ${section === 6 ? "training-btn-seen" : "bg-[#F5F5F5] text-semi-gray"} `}
                        onClick={() => setSection(6)}
                    >
                        {t('training-courses.high-certificate')}
                    </button>
                )}

            </div>
            <div className="border rounded-md p-3">{returnedSection[section]}</div>
            {
                !comingFromOffer && <OnlineAndOffline />
            }
        </div>
    );
};

export default TRCourseData;